
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"15","height":"15"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#FF0C00","fill-rule":"evenodd","d":"M7.5 15a7.5 7.5 0 110-15 7.5 7.5 0 010 15zM8 3H7v6h1V3zm-.5 6.999a1.001 1.001 0 10.002 2.002A1.001 1.001 0 007.5 10z"}})])
          )
        }
      }
    